import apiV2Service from '../api/api-v2.service';
import {PostDataObj} from '../api/apiTypes';
import {JobExecutionParams} from '../jobs/jobs.types';
import {
  CreateAiContentItemRequest,
  CreateMultipleAiContentItemsRequest,
  GenerateAssetsRequest,
  IsPromptGenerationNeededRequest,
  IsPromptGenerationNeededResponse,
  RemoteAiContentItem,
  UpdateAiContentItemRequest,
  UpdatePromptsRequest,
} from './aiContentItem.types';

const BASE_PATH = 'ai-content-items';

async function getAiContentItemsByProjectId(
  projectId: number,
): Promise<RemoteAiContentItem[]> {
  const {data} = await apiV2Service.executeGetRequest<RemoteAiContentItem[]>(
    `${BASE_PATH}/project/${projectId}`,
  );

  return data;
}

async function getAiContentItemById(
  id: number,
): Promise<RemoteAiContentItem> {
  const {data} = await apiV2Service.executeGetRequest<RemoteAiContentItem>(
    `${BASE_PATH}/${id}`,
  );

  return data;
}

async function createAiContentItem(
  request: CreateAiContentItemRequest,
): Promise<RemoteAiContentItem> {
  const {data} = await apiV2Service.executePutRequest<RemoteAiContentItem>(
    BASE_PATH,
    {},
    request as unknown as PostDataObj,
  );

  return data;
}

async function createMultipleAiContentItems(
  request: CreateMultipleAiContentItemsRequest,
): Promise<void> {
  await apiV2Service.executePostRequest<void>(
    `${BASE_PATH}/batch`,
    {},
    request as unknown as PostDataObj,
  );
}

async function updateAiContentItem({
  id,
  request,
}: {
  id: number;
  request: UpdateAiContentItemRequest;
}): Promise<void> {
  await apiV2Service.executePutRequest<void>(
    `${BASE_PATH}/${id}`,
    {},
    request as unknown as PostDataObj,
  );
}

async function deleteAiContentItem(id: number): Promise<void> {
  await apiV2Service.executeDeleteRequest<void>(`${BASE_PATH}/${id}`);
}

async function generateAssets(projectId: number, request: GenerateAssetsRequest): Promise<number> {
  const {
    data: {executionId},
  } = await apiV2Service.executePostRequest<JobExecutionParams>(
    `${BASE_PATH}/project/${projectId}/generate-assets`,
    {},
    request as unknown as PostDataObj,
  );

  return executionId;
}

async function updateOutputPrompts(request: UpdatePromptsRequest): Promise<number> {
  const {
    data: {executionId},
  } = await apiV2Service.executePostRequest<JobExecutionParams>(
    `${BASE_PATH}/update-prompts`,
    {},
    request as unknown as PostDataObj,
  );

  return executionId;
}

async function setActiveIntermediateImageIndex(
  itemId: number,
  deliverableKey: string,
  index: number,
): Promise<void> {
  await apiV2Service.executePutRequest<void>(
    `${BASE_PATH}/${itemId}/deliverables/${deliverableKey}/active-intermediate/${index}`,
    {},
    {},
  );
}

async function isPromptGenerationNeeded(
  projectId: number,
  request: IsPromptGenerationNeededRequest,
): Promise<IsPromptGenerationNeededResponse> {
  const {data} = await apiV2Service.executePostRequest<IsPromptGenerationNeededResponse>(
    `${BASE_PATH}/project/${projectId}/is-prompt-generation-needed`,
    {},
    request as unknown as PostDataObj,
  );

  return data;
}

const aiContentItemApi = {
  getAiContentItemsByProjectId,
  getAiContentItemById,
  createAiContentItem,
  createMultipleAiContentItems,
  updateAiContentItem,
  deleteAiContentItem,
  generateAssets,
  updateOutputPrompts,
  setActiveIntermediateImageIndex,
  isPromptGenerationNeeded,
};

export default aiContentItemApi;
